import * as React from 'react';
import s from './Status.scss';
import { Badge } from 'wix-style-react';
import { translate } from 'react-i18next';
import { WithStatusLoader } from '../../loaders/loaders-builder';
export var UoUStatuses = ['Accepted', 'Invoiced', 'Expired'];
export var priceQuoteStatuses = ['Accepted', 'Draft', 'Sent', 'Expired', 'Invoiced'];
var Status = function (_a) {
    var status = _a.status, isUoU = _a.isUoU, t = _a.t;
    var renderedStatus = status;
    var isDisplayed = !isUoU || UoUStatuses.includes(renderedStatus);
    var text = t("invoice-view:price-quote.view.status.".concat(renderedStatus));
    var skin = {
        Accepted: 'standard',
        Draft: 'neutral',
        Sent: 'neutralStandard',
        Expired: 'neutralDanger',
        Invoiced: 'neutralSuccess',
    }[renderedStatus] || 'warning';
    return (isDisplayed && (React.createElement("div", { className: s.status, "data-hook": "status" },
        React.createElement(Badge, { dataHook: "status-badge", skin: skin, uppercase: false }, text))));
};
export default WithStatusLoader(translate(['invoice-view', 'locale-data'])(Status));
//# sourceMappingURL=Status.js.map